import authHeader from 'srcReact/helpers/auth-header'
import { doRequestAxios } from 'srcReact/helpers/apiHelper'

export const integrationService = {
  getAvailableOrgConnections,
  getActiveIntegrations,
  setDefaultAddToCalendar,
  setDefaultVirtualMeeting,
  saveExternalAPIToken,
  getExternalAPIConnection,
  revokeToken,
  updateIntegration,
  setGoogleTranslationKey
}

function getActiveIntegrations(organizationId, usage) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params: { organization_id: organizationId, usage }
  }
  return doRequestAxios('/v2/user/external-apis/get-connections', requestOptions)
}

function setDefaultAddToCalendar(calendarType, organizationId, authToken) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    data: {
      calendar_type: calendarType === 'google' ? 'gcal' : calendarType === 'microsoft' ? 'microsoftcal' : calendarType,
      organization_id: organizationId,
      ...(authToken ? { id_external_api_auth: authToken } : {})
    }
  }
  return doRequestAxios('/v2/set-default-add-to-calendar', requestOptions)
}

function setDefaultVirtualMeeting(meetingType, organizationId, authToken) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    params: {
      meeting_type: meetingType,
      organization_id: organizationId,
      id_external_api_auth: authToken
    }
  }
  return doRequestAxios('/v2/set-default-meeting', requestOptions)
}

function saveExternalAPIToken(
  type,
  code,
  setUseForCalendar,
  setUseForMeeting,
  setAddToCalendarDefault,
  setMeetingDefault,
  organizationId
) {
  const params = {
    code,
    set_use_for_calendar: setUseForCalendar,
    set_use_for_meeting: setUseForMeeting,
    set_add_to_calendar_default: setAddToCalendarDefault,
    set_meeting_default: setMeetingDefault,
    organization_id: organizationId
  }
  if (!params.set_use_for_calendar) {
    delete params.set_use_for_calendar
  }
  if (!params.set_use_for_meeting) {
    delete params.set_use_for_meeting
  }
  if (!params.set_add_to_calendar_default) {
    delete params.set_add_to_calendar_default
  }
  if (!params.set_meeting_default) {
    delete params.set_meeting_default
  }
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    data: params
  }
  let url = ''
  if (type === 'google' || type === 'gcal') url = '/v2/google-auth-add'
  else if (type === 'microsoft' || type === 'microsoftcal') {
    url = '/v2/microsoft-auth-add'
  } else if (type === 'zoom') {
    url = '/v2/zoom-auth-add'
  }
  return doRequestAxios(url, requestOptions)
}

function getExternalAPIConnection(type, organizationId, authToken) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params: { organization_id: organizationId, id_external_api_auth: authToken }
  }
  let url = ''
  if (type === 'google' || type === 'gcal') url = '/v2/google-auth-check'
  else if (type === 'microsoft' || type === 'microsoftcal') {
    url = '/v2/microsoft-auth-check'
  } else if (type === 'zoom') {
    url = '/v2/zoom-auth-check'
  }
  return doRequestAxios(url, requestOptions)
}

function revokeToken(type, organizationId, authToken) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    data: { organization_id: organizationId, id_external_api_auth: authToken }
  }
  let url = ''
  if (type === 'google' || type === 'gcal') {
    url = '/v2/google-auth-revoke'
  } else if (type === 'microsoft' || type === 'microsoftcal') {
    url = '/v2/microsoft-auth-revoke'
  } else if (type === 'zoom') {
    url = '/v2/zoom-auth-revoke'
  }

  return doRequestAxios(url, requestOptions)
}

function getAvailableOrgConnections(organizationId) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params: { organization_id: organizationId }
  }

  return doRequestAxios('/v2/organization/external-apis/get', requestOptions)
}

function updateIntegration(organizationId, externalApiType, usage, action, key) {
  const dataParams = { organization_id: organizationId, external_api: externalApiType, usage, action }
  if (externalApiType === 'google' && usage === 'translate' && action === 'activate') {
    dataParams.key = key
  }
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    data: dataParams
  }

  return doRequestAxios('/v2/organization/external-apis/update', requestOptions)
}

function setGoogleTranslationKey(organizationId, key) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    data: { organization_id: organizationId, key }
  }

  return doRequestAxios('/v2/organization/set-google-translation-key', requestOptions)
}
